<script>
// import Schema from '@/components/bundles/share/form/type/common/form/Schema' // form with metadata
import Schema from '@/components/bundles/share/mixins/Schema.js'

export default {
  name: 'form-schema',
  mixins: [
    Schema
  ],
  props: {
    service: {
      type: String,
      required: true
    }
  }
}
</script>
